export function getDefaultReviewExpiry(hireDate, intervalDays) {
  const match = String(hireDate || "").match(/^(\d{4}-\d{2}-\d{2})/);
  if (!match || ![45, 90].includes(intervalDays)) return "";
  const date = new Date(`${match[1]}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== match[1]) return "";
  date.setUTCDate(date.getUTCDate() + intervalDays);
  return date.toISOString().slice(0, 10);
}
